import { render, staticRenderFns } from "./getStatementModel.vue?vue&type=template&id=2c88ef14&scoped=true"
import script from "./getStatementModel.vue?vue&type=script&lang=js"
export * from "./getStatementModel.vue?vue&type=script&lang=js"
import style0 from "./getStatementModel.vue?vue&type=style&index=0&id=2c88ef14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88ef14",
  null
  
)

export default component.exports